(function (global) {
  'use strict';

  var COMPONENT_NAME = 'vl-blog-product-showcase';
  var SHORTCODE_SELECTOR = '[data-vl-blog-product-showcase]';
  var bodyLockCount = 0;
  var productUid = 0;

  function uniqueHandles(element) {
    var seen = new Set();
    var handles = [];

    for (var index = 1; index <= 3; index += 1) {
      var handle = String(element.getAttribute('data-product-' + index + '-handle') || '').trim();
      if (!handle || seen.has(handle)) continue;
      seen.add(handle);
      handles.push(handle);
    }

    return handles;
  }

  function productViewUrl(handle) {
    var root = global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : '/';
    root = String(root || '/');
    if (root.slice(-1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '?view=vl-blog-product-showcase';
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var value = ((Number(cents) || 0) / 100).toFixed(precision);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents, format) {
    if (global.Shopify && typeof global.Shopify.formatMoney === 'function') {
      return global.Shopify.formatMoney(cents, format).replace(/([.,])00(?=\D*$)/, '');
    }

    var moneyFormat = format || '${{amount}}';
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return '$' + formatWithDelimiters(cents, 2, ',', '.');

    var formatted = {
      amount: formatWithDelimiters(cents, 2, ',', '.'),
      amount_no_decimals: formatWithDelimiters(cents, 0, ',', '.'),
      amount_with_comma_separator: formatWithDelimiters(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: formatWithDelimiters(cents, 0, '.', ',')
    }[match[1]] || formatWithDelimiters(cents, 2, ',', '.');

    return moneyFormat.replace(match[0], formatted).replace(/([.,])00(?=\D*$)/, '');
  }

  function textFromHtml(html, ownerDocument) {
    var element = ownerDocument.createElement('span');
    element.innerHTML = html;
    return element.textContent || '';
  }

  function variantImageUrl(variant, fallback) {
    var image = variant && (variant.featured_image || variant.featured_media);
    if (typeof image === 'string') return image;
    if (image && image.src) return image.src;
    if (image && image.preview_image && image.preview_image.src) return image.preview_image.src;
    return fallback || '';
  }

  function renderDialogGift(product, giftData, variantId) {
    var media = product.querySelector('.vl-blog-product-showcase__dialog-media');
    if (!media) return;

    var list = giftData && Array.isArray(giftData.byVariant) ? giftData.byVariant : [];
    var entry = list.find(function (item) {
      return String(item.id) === String(variantId);
    });
    var gift = entry && entry.gift;
    var existing = media.querySelector('[data-vl-product-card-gift]');

    if (!gift) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'vl-product-card__gift vl-blog-product-showcase__dialog-gift';
      existing.setAttribute('data-vl-product-card-gift', '');
      media.appendChild(existing);
    }

    existing.setAttribute('data-vl-product-card-gift-id', gift.id);
    existing.style.setProperty('--vl-pc-gift-bg', gift.bg || '#fffaed');
    existing.style.setProperty('--vl-pc-gift-border', gift.border || '#fede81');
    existing.style.setProperty('--vl-pc-gift-font', gift.color || '#1f1f1f');
    existing.setAttribute('data-gift-border-mode', gift.borderImage ? 'image' : 'color');

    var border = existing.querySelector('.vl-product-card__gift-border');
    if (gift.borderImage) {
      if (!border) {
        border = document.createElement('img');
        border.className = 'vl-product-card__gift-border';
        border.width = 54;
        border.height = 74;
        border.alt = '';
        border.loading = 'lazy';
        border.setAttribute('aria-hidden', 'true');
        existing.appendChild(border);
      }
      border.src = gift.borderImage;
    } else if (border) {
      border.remove();
    }

    var title = existing.querySelector('.vl-product-card__gift-title');
    if (gift.title) {
      if (!title) {
        title = document.createElement('span');
        title.className = 'vl-product-card__gift-title';
        existing.prepend(title);
      }
      title.textContent = gift.title;
    } else if (title) {
      title.remove();
    }

    var giftMedia = existing.querySelector('.vl-product-card__gift-media');
    if (!giftMedia) {
      giftMedia = document.createElement('div');
      giftMedia.className = 'vl-product-card__gift-media';
      if (border) existing.insertBefore(giftMedia, border);
      else existing.appendChild(giftMedia);
    }

    Array.prototype.forEach.call(giftMedia.querySelectorAll('.vl-product-card__gift-image, .vl-product-card__gift-plus'), function (node) {
      node.remove();
    });

    var images = Array.isArray(gift.images) ? gift.images : [];
    if (!images.length && gift.image) images = [{ src: gift.image, src2x: gift.image2x }];
    var count = Math.min(images.length, 4);
    existing.setAttribute('data-gift-count', String(count));

    images.slice(0, count).forEach(function (imageData) {
      if (!imageData || !imageData.src) return;
      var image = document.createElement('img');
      image.className = 'vl-product-card__gift-image';
      image.width = count === 1 ? 48 : (count === 2 ? 32 : 28);
      image.height = image.width;
      image.alt = '';
      image.loading = 'lazy';
      image.src = imageData.src;
      if (imageData.src2x) image.srcset = imageData.src + ' 1x, ' + imageData.src2x + ' 2x';
      giftMedia.appendChild(image);
    });

    if (count > 1) {
      var plus = document.createElement('span');
      plus.className = 'vl-product-card__gift-plus';
      plus.textContent = '+';
      plus.setAttribute('aria-hidden', 'true');
      giftMedia.appendChild(plus);
    }
  }

  function setBodyLocked(locked, ownerDocument) {
    if (!ownerDocument || !ownerDocument.body) return;
    bodyLockCount = Math.max(0, bodyLockCount + (locked ? 1 : -1));
    ownerDocument.body.classList.toggle('vl-blog-product-showcase-dialog-open', bodyLockCount > 0);
  }

  function upgradeShortcode(element) {
    if (!element || !element.ownerDocument) return null;
    if (String(element.tagName || '').toLowerCase() === COMPONENT_NAME) return element;

    var upgraded = element.ownerDocument.createElement(COMPONENT_NAME);
    Array.from(element.attributes || []).forEach(function (attribute) {
      upgraded.setAttribute(attribute.name, attribute.value);
    });
    element.replaceWith(upgraded);
    return upgraded;
  }

  function initShortcodes(root) {
    var scope = root && root.querySelectorAll ? root : global.document;
    if (!scope || !scope.querySelectorAll) return [];
    var elements = Array.from(scope.querySelectorAll(SHORTCODE_SELECTOR));
    if (scope.matches && scope.matches(SHORTCODE_SELECTOR)) elements.unshift(scope);
    return elements.map(upgradeShortcode).filter(Boolean);
  }

  var HTMLElementBase = global.HTMLElement || class {};

  class VlBlogProductShowcase extends HTMLElementBase {
    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.handles = uniqueHandles(this);
      this.productStates = new Map();
      this.activeIndex = 0;
      this.activeTrigger = null;
      this.openDialog = null;
      this.suppressFocusRestore = false;
      this.dialogCloseTimer = null;
      this.scrollSettleTimer = null;
      this.infoMarqueeObserver = null;
      this.infoMarqueeFontHandler = null;
      this.eventController = new AbortController();
      this.requestController = new AbortController();

      this.classList.add('vl-blog-product-showcase');
      if (!this.handles.length) {
        this.hidden = true;
        this.dataset.vlBlogProductShowcaseError = 'missing-product-handle';
        return;
      }

      this.rteHost = this.closest('.rte');
      if (this.rteHost) this.rteHost.classList.add('vl-blog-product-showcase-host');

      this.hidden = false;
      this.renderShell();
      this.bindEvents();
      this.observeInfoMarquee();
      this.loadProducts();
    }

    disconnectedCallback() {
      var rteHost = this.rteHost;
      if (this.requestController) this.requestController.abort();
      if (this.eventController) this.eventController.abort();
      if (this.scrollSettleTimer) global.clearTimeout(this.scrollSettleTimer);
      if (this.dialogCloseTimer) global.clearTimeout(this.dialogCloseTimer);
      if (this.infoMarqueeObserver) this.infoMarqueeObserver.disconnect();
      if (this.infoMarqueeFontHandler && this.ownerDocument.fonts && this.ownerDocument.fonts.removeEventListener) {
        this.ownerDocument.fonts.removeEventListener('loadingdone', this.infoMarqueeFontHandler);
      }
      if (this.openDialog && this.openDialog.open) this.openDialog.close();
      this.unlockDialog();
      this.requestController = null;
      this.eventController = null;
      this.scrollSettleTimer = null;
      this.dialogCloseTimer = null;
      this.infoMarqueeObserver = null;
      this.infoMarqueeFontHandler = null;
      this.suppressFocusRestore = false;
      this.rteHost = null;
      this.productStates = new Map();
      this.isInitialized = false;
      if (rteHost && !rteHost.querySelector(COMPONENT_NAME)) {
        rteHost.classList.remove('vl-blog-product-showcase-host');
      }
    }

    renderShell() {
      var slots = this.handles.map(function (handle) {
        return '<div class="vl-blog-product-showcase__loading" data-product-handle="' +
          String(handle).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;') +
          '" role="status"><span class="visually-hidden">Loading product</span></div>';
      }).join('');

      this.innerHTML =
        '<div class="vl-blog-product-showcase__viewport" data-vl-blog-product-viewport>' +
          '<div class="vl-blog-product-showcase__track" data-vl-blog-product-track>' + slots + '</div>' +
        '</div>' +
        '<div class="vl-blog-product-showcase__controls" data-vl-blog-product-controls>' +
          '<div class="vl-blog-product-showcase__dots" data-vl-blog-product-dots></div>' +
          '<div class="vl-blog-product-showcase__arrows">' +
            '<button class="vl-blog-product-showcase__control" type="button" aria-label="Previous product" data-vl-blog-product-previous>' +
              '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="17.5" fill="#f2f3f5"/><path d="M23.7752 27.6893C24.1657 27.2988 24.1657 26.6656 23.7752 26.2751L17.5 19.9999L23.7752 13.7247C24.1657 13.3342 24.1657 12.701 23.7752 12.3105L23.4216 11.9569C23.0311 11.5664 22.3979 11.5664 22.0074 11.9569L14.6715 19.2928C14.281 19.6833 14.281 20.3165 14.6715 20.707L22.0074 28.0429C22.3979 28.4334 23.0311 28.4334 23.4216 28.0429L23.7752 27.6893Z" fill="currentColor"/></svg>' +
            '</button>' +
            '<button class="vl-blog-product-showcase__control" type="button" aria-label="Next product" data-vl-blog-product-next>' +
              '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="17.5" fill="#f2f3f5"/><path d="M16.2248 12.3107C15.8343 12.7012 15.8343 13.3343 16.2248 13.7249L22.5 20.0001L16.2248 26.2753C15.8343 26.6658 15.8343 27.299 16.2248 27.6895L16.5784 28.0431C16.9689 28.4336 17.6021 28.4336 17.9926 28.0431L25.3285 20.7072C25.719 20.3167 25.719 19.6835 25.3285 19.293L17.9926 11.9571C17.6021 11.5666 16.9689 11.5666 16.5784 11.9571L16.2248 12.3107Z" fill="currentColor"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>';

      this.track = this.querySelector('[data-vl-blog-product-track]');
      this.dots = this.querySelector('[data-vl-blog-product-dots]');
      this.previousButton = this.querySelector('[data-vl-blog-product-previous]');
      this.nextButton = this.querySelector('[data-vl-blog-product-next]');
      this.setAttribute('aria-busy', 'true');
      this.dataset.productCount = '0';
    }

    bindEvents() {
      var signal = this.eventController.signal;
      this.addEventListener('click', this.handleAddClick.bind(this), { capture: true, signal: signal });
      this.addEventListener('click', this.handleClick.bind(this), { signal: signal });
      this.addEventListener('cancel', this.handleDialogCancel.bind(this), { capture: true, signal: signal });
      this.addEventListener('close', this.handleDialogClose.bind(this), { capture: true, signal: signal });
      this.track.addEventListener('scroll', this.handleScroll.bind(this), { passive: true, signal: signal });
      global.addEventListener('resize', this.handleResize.bind(this), { passive: true, signal: signal });
    }

    observeInfoMarquee() {
      var self = this;
      var fonts = this.ownerDocument.fonts;

      if (fonts && fonts.ready) {
        fonts.ready.then(function () {
          if (self.isConnected && global.VLInfoMarquee) global.VLInfoMarquee.schedule(self);
        });
      }

      if (fonts && fonts.addEventListener) {
        this.infoMarqueeFontHandler = function () {
          if (self.isConnected && global.VLInfoMarquee) global.VLInfoMarquee.schedule(self);
        };
        fonts.addEventListener('loadingdone', this.infoMarqueeFontHandler);
      }

      if (global.ResizeObserver) {
        var lastWidth = this.clientWidth;
        this.infoMarqueeObserver = new global.ResizeObserver(function () {
          if (self.clientWidth === lastWidth) return;
          lastWidth = self.clientWidth;
          if (global.VLInfoMarquee) global.VLInfoMarquee.schedule(self);
        });
        this.infoMarqueeObserver.observe(this);
      }
    }

    handleProductSubmit(event) {
      var form = event.currentTarget || event.target;
      if (!form || !form.matches || !form.matches('.vl-blog-product-showcase__product-form form')) return;
      var dialog = form.closest('[data-vl-blog-product-dialog]');
      var product = form.closest('[data-vl-blog-product-response]');
      var state = product && this.productStates.get(product);
      var freeItemHost = form.closest('.vl-blog-product-showcase__product-form[data-freeitem]');
      if (state && state.currentPurchase && freeItemHost) {
        var freeItemValue = freeItemHost.getAttribute('data-freeitem');
        freeItemHost.setAttribute('data-freeitem', '');
        global.setTimeout(function () {
          if (freeItemValue == null) freeItemHost.removeAttribute('data-freeitem');
          else freeItemHost.setAttribute('data-freeitem', freeItemValue);
        }, 0);
      }
      var addButton = form.querySelector('[data-vl-blog-product-add]');
      if (!dialog || !dialog.open || !addButton || addButton.disabled) return;

      this.suppressFocusRestore = true;
      this.closeProductDialog(dialog, true);
    }

    handleAddClick(event) {
      var addButton = event.target.closest && event.target.closest('[data-vl-blog-product-add]');
      if (!addButton || !this.contains(addButton) || addButton.disabled) return;
      var dialog = addButton.closest('[data-vl-blog-product-dialog]');
      if (!dialog || !dialog.open) return;

      this.suppressFocusRestore = true;
      this.closeProductDialog(dialog, true);
    }

    loadProducts() {
      var self = this;
      var requests = this.handles.map(function (handle, index) {
        return self.loadProduct(handle, index);
      });

      Promise.allSettled(requests).then(function () {
        if (!self.isConnected) return;
        self.finishLoading();
      });
    }

    loadProduct(handle, index) {
      var self = this;
      return global.fetch(productViewUrl(handle), {
        credentials: 'same-origin',
        signal: this.requestController.signal
      }).then(function (response) {
        if (!response.ok) throw new Error('Product not found: ' + handle);
        return response.text();
      }).then(function (html) {
        if (!self.isConnected) return;
        var documentFragment = new global.DOMParser().parseFromString(html, 'text/html');
        var product = documentFragment.querySelector('[data-vl-blog-product-response]');
        if (!product) throw new Error('Invalid product response: ' + handle);
        var importedProduct = self.ownerDocument.importNode(product, true);
        var slot = self.track.children[index];
        if (!slot) return;
        slot.replaceWith(importedProduct);
        self.initializeProduct(importedProduct);
      }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (!self.isConnected) return;
        self.renderProductError(index, handle);
        console.warn('[VL Blog product showcase] Failed to load product.', error);
      });
    }

    renderProductError(index, handle) {
      var slot = this.track.children[index];
      if (!slot) return;
      slot.className = 'vl-blog-product-showcase__error';
      slot.removeAttribute('role');
      slot.textContent = 'Unable to load ' + handle + '.';
    }

    initializeProduct(product) {
      var dataElement = product.querySelector('[data-vl-blog-product-data]');
      if (!dataElement) return;

      try {
        productUid += 1;
        var data = JSON.parse(dataElement.textContent);
        var variantApi = global.VelotricProductCardVariant;
        if (!variantApi) throw new Error('Product variant controller is unavailable.');
        var hiddenIds = new Set((data.hiddenVariantIds || []).map(String));
        var visibleVariants = (data.variants || []).filter(function (variant) {
          return !hiddenIds.has(String(variant.id));
        });
        var hiddenVariants = (data.variants || []).filter(function (variant) {
          return hiddenIds.has(String(variant.id));
        });
        var currentVariant = visibleVariants.find(function (variant) {
          return String(variant.id) === String(data.initialVariantId);
        }) || visibleVariants.find(function (variant) { return variant.available; }) || visibleVariants[0] || null;

        var state = {
          data: data,
          config: {
            optionNames: data.optionNames || [],
            fallbackImageUrl: data.fallbackImageUrl,
            productUrl: data.url
          },
          variants: visibleVariants,
          hiddenVariants: hiddenVariants,
          extraPurchaseRecords: variantApi.prepareExtraPurchaseRecords(data.extraPurchaseRecords),
          visibleVariants: visibleVariants,
          selectedOptions: variantApi.selectedOptionsFromVariant(data.optionNames || [], currentVariant),
          currentVariant: currentVariant,
          currentPurchase: null
        };
        var dialog = product.querySelector('[data-vl-blog-product-dialog]');
        var dialogTitle = product.querySelector('.vl-blog-product-showcase__dialog-title');
        if (dialog && dialogTitle) {
          dialogTitle.id = 'VLBlogProductDialogTitle-' + productUid;
          dialog.setAttribute('aria-labelledby', dialogTitle.id);
        }
        var productForm = product.querySelector('.vl-blog-product-showcase__product-form form[id]');
        if (productForm) {
          productForm.id = 'VLBlogProductForm-' + productUid;
          productForm.addEventListener('submit', this.handleProductSubmit.bind(this), {
            signal: this.eventController.signal
          });
        }
        this.renderExtraPurchaseButtons(product, state);
        var defaultPurchase = variantApi.findDefaultExtraPurchase(
          state.extraPurchaseRecords,
          state.config.optionNames,
          state.selectedOptions,
          state.config
        );
        if (defaultPurchase) {
          state.currentPurchase = { record: defaultPurchase.record, product: defaultPurchase.product };
          state.selectedOptions = variantApi.mergeSelectedOptionsFromPurchaseVariant(
            state.config.optionNames,
            state.selectedOptions,
            defaultPurchase.product,
            defaultPurchase.variant,
            defaultPurchase.record.targetOptionNormalized
          );
          state.currentVariant = defaultPurchase.variant;
        }
        this.productStates.set(product, state);
        this.updateProduct(product, state);
        if (global.VLInfoMarquee) global.VLInfoMarquee.schedule(product);
      } catch (error) {
        console.warn('[VL Blog product showcase] Invalid product data.', error);
      }
    }

    finishLoading() {
      var products = Array.from(this.track.querySelectorAll(':scope > [data-vl-blog-product-response]'));
      products.forEach(function (product) { product.classList.remove('is-wide'); });
      if (products.length === 1) products[0].classList.add('is-wide');
      if (products.length === 3) products[2].classList.add('is-wide');
      this.dataset.productCount = String(products.length);
      this.removeAttribute('aria-busy');
      this.renderDots();
      this.syncCarousel(0);
      if (global.VLInfoMarquee) global.VLInfoMarquee.schedule(this);
    }

    renderDots() {
      var slides = Array.from(this.track.children);
      var ownerDocument = this.ownerDocument;
      this.dots.replaceChildren();
      slides.forEach(function (_slide, index) {
        var button = ownerDocument.createElement('button');
        button.className = 'vl-blog-product-showcase__dot';
        button.type = 'button';
        button.setAttribute('aria-label', 'Show product ' + (index + 1));
        button.setAttribute('data-vl-blog-product-dot', String(index));
        this.dots.appendChild(button);
      }, this);
    }

    handleClick(event) {
      var extraPurchaseOption = event.target.closest('[data-vl-blog-extra-purchase-product-id]');
      if (extraPurchaseOption && this.contains(extraPurchaseOption)) {
        this.selectExtraPurchase(extraPurchaseOption);
        return;
      }

      var option = event.target.closest('[data-vl-blog-product-option]');
      if (option && this.contains(option)) {
        this.selectOption(option);
        return;
      }

      var openButton = event.target.closest('[data-vl-blog-product-open]');
      if (openButton && this.contains(openButton)) {
        event.preventDefault();
        this.showProductDialog(openButton);
        return;
      }

      var closeButton = event.target.closest('[data-vl-blog-product-close]');
      if (closeButton && this.contains(closeButton)) {
        this.closeProductDialog(closeButton.closest('[data-vl-blog-product-dialog]'), true);
        return;
      }

      var dialog = event.target.closest('[data-vl-blog-product-dialog]');
      if (dialog && event.target === dialog) {
        this.closeProductDialog(dialog, true);
        return;
      }

      var dot = event.target.closest('[data-vl-blog-product-dot]');
      if (dot && this.contains(dot)) {
        this.scrollToIndex(Number(dot.getAttribute('data-vl-blog-product-dot')) || 0);
        return;
      }

      if (event.target.closest('[data-vl-blog-product-previous]')) this.scrollToIndex(this.activeIndex - 1);
      if (event.target.closest('[data-vl-blog-product-next]')) this.scrollToIndex(this.activeIndex + 1);
    }

    selectOption(button) {
      if (button.disabled || button.hidden) return;
      var product = button.closest('[data-vl-blog-product-response]');
      var state = this.productStates.get(product);
      if (!state) return;

      var variantApi = global.VelotricProductCardVariant;
      var optionName = button.getAttribute('data-option-name') || state.config.optionNames[Number(button.getAttribute('data-option-index'))];
      var optionValue = button.getAttribute('data-option-value');
      var selectedOptions = variantApi.applyProductRules(state.selectedOptions, optionName, optionValue, state.config);
      var purchase = state.currentPurchase;
      var normalizedOptionName = variantApi.normalize(optionName);
      if (purchase && normalizedOptionName === purchase.record.targetOptionNormalized) {
        state.currentPurchase = null;
        purchase = null;
      }
      var usePurchase = Boolean(
        purchase
        && normalizedOptionName !== purchase.record.targetOptionNormalized
        && purchase.product.optionIndexes
        && variantApi.getOptionNameAliases(optionName).some(function (alias) {
          return purchase.product.optionIndexes.has(alias);
        })
      );
      var optionState = variantApi.getOptionStateForState(state, optionName, optionValue, selectedOptions);
      var currentVariant = variantApi.findPreferredAvailableVariant(
        optionState.matches,
        state.config.optionNames,
        optionState.selectedOptions,
        usePurchase ? purchase.product.optionIndexes : null,
        usePurchase ? purchase.record.targetOptionNormalized : null
      );
      if (!currentVariant) return;
      if (usePurchase) {
        state.selectedOptions = variantApi.mergeSelectedOptionsFromPurchaseVariant(
          state.config.optionNames,
          optionState.selectedOptions,
          purchase.product,
          currentVariant,
          purchase.record.targetOptionNormalized
        );
      } else {
        state.currentPurchase = null;
        state.selectedOptions = variantApi.selectedOptionsFromVariant(state.config.optionNames, currentVariant);
      }
      state.currentVariant = currentVariant;
      this.updateProduct(product, state);
    }

    renderExtraPurchaseButtons(product, state) {
      var variantApi = global.VelotricProductCardVariant;
      state.extraPurchaseRecords.forEach(function (record) {
        var targetOptionIndex = state.config.optionNames.findIndex(function (optionName) {
          return variantApi.normalize(optionName) === record.targetOptionNormalized;
        });
        var group = product.querySelector('[data-vl-blog-product-option-group][data-option-index="' + targetOptionIndex + '"]');
        var host = group && group.querySelector('.vl-blog-product-showcase__option-values');
        var nativeAnchor = host && host.querySelector('[data-vl-blog-product-option]');
        if (!host || !nativeAnchor) return;
        record.products.forEach(function (purchaseProduct) {
          var button = product.ownerDocument.createElement('button');
          button.type = 'button';
          button.className = 'vl-blog-product-showcase__option-button';
          button.textContent = purchaseProduct.title;
          button.setAttribute('role', 'radio');
          button.setAttribute('aria-checked', 'false');
          button.setAttribute('data-vl-blog-extra-purchase-product-id', String(purchaseProduct.id));
          button.setAttribute('data-vl-blog-extra-purchase-target-option', record.targetOptionNormalized);
          if (purchaseProduct.isPurchaseFirst === true) host.insertBefore(button, nativeAnchor);
          else host.appendChild(button);
        });
      });
    }

    selectExtraPurchase(button) {
      if (button.disabled || button.hidden) return;
      var product = button.closest('[data-vl-blog-product-response]');
      var state = this.productStates.get(product);
      var variantApi = global.VelotricProductCardVariant;
      if (!state || !variantApi) return;
      var productId = button.getAttribute('data-vl-blog-extra-purchase-product-id');
      var targetOption = button.getAttribute('data-vl-blog-extra-purchase-target-option');
      var record = state.extraPurchaseRecords.find(function (item) {
        return item.targetOptionNormalized === targetOption;
      });
      var purchaseProduct = record && record.products.find(function (item) {
        return String(item.id) === String(productId);
      });
      if (!purchaseProduct) return;
      var matches = variantApi.findPurchaseFunnelVariants(
        purchaseProduct,
        record,
        state.config.optionNames,
        state.selectedOptions,
        state.config,
        false
      );
      var currentVariant = variantApi.findPreferredAvailableVariant(
        matches,
        state.config.optionNames,
        state.selectedOptions,
        purchaseProduct.optionIndexes,
        record.targetOptionNormalized
      );
      if (!currentVariant) return;
      state.currentPurchase = { record: record, product: purchaseProduct };
      state.selectedOptions = variantApi.mergeSelectedOptionsFromPurchaseVariant(
        state.config.optionNames,
        state.selectedOptions,
        purchaseProduct,
        currentVariant,
        record.targetOptionNormalized
      );
      state.currentVariant = currentVariant;
      this.updateProduct(product, state);
    }

    updateProduct(product, state) {
      var self = this;
      var variant = state.currentVariant;
      if (!variant) {
        var emptyVariantInput = product.querySelector('[data-vl-blog-product-variant-input]');
        if (emptyVariantInput) {
          emptyVariantInput.value = '';
          emptyVariantInput.setAttribute('value', '');
          emptyVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var unavailableAddButton = product.querySelector('[data-vl-blog-product-add]');
        if (unavailableAddButton) {
          unavailableAddButton.disabled = true;
          var unavailableAddLabel = unavailableAddButton.querySelector('[data-vl-blog-product-add-label]');
          if (unavailableAddLabel) unavailableAddLabel.textContent = 'Unavailable';
        }
        var unavailableRiderHeight = product.querySelector('[data-vl-blog-product-rider-height]');
        if (unavailableRiderHeight) unavailableRiderHeight.hidden = true;
        this.updateOptions(product, state);
        return;
      }
      var price = variant ? Number(variant.price) || 0 : 0;
      var comparePrice = variant ? Number(variant.compare_at_price) || 0 : 0;
      var giftValue = !state.currentPurchase && variant && state.data.giftValues ? Number(state.data.giftValues[String(variant.id)]) || 0 : 0;
      var savings = Math.max(0, comparePrice - price) + giftValue;
      var imageUrl = variantImageUrl(variant, state.currentPurchase && state.currentPurchase.product.featuredImageUrl || state.data.fallbackImageUrl);
      var targetVariant = global.VelotricProductCardVariant.findExactVariant(
        state.visibleVariants,
        state.config.optionNames,
        state.selectedOptions
      ) || state.visibleVariants[0];
      var productUrl = state.data.url + (targetVariant ? '?variant=' + targetVariant.id : '');

      product.querySelectorAll('[data-vl-blog-product-price]').forEach(function (element) {
        element.innerHTML = formatMoney(price, state.data.moneyFormat);
      });
      product.querySelectorAll('[data-vl-blog-product-compare-price]').forEach(function (element) {
        element.hidden = !(comparePrice > price);
        element.innerHTML = comparePrice > price ? formatMoney(comparePrice, state.data.moneyFormat) : '';
      });
      product.querySelectorAll('[data-vl-blog-product-save]').forEach(function (element) {
        element.hidden = savings <= 0;
        element.textContent = savings > 0 ? 'Save ' + textFromHtml(formatMoney(savings, state.data.moneyFormat), self.ownerDocument) : '';
      });
      product.querySelectorAll('[data-vl-blog-product-link]').forEach(function (element) {
        element.href = productUrl;
      });
      product.querySelectorAll('.vl-blog-product-showcase__dialog-image').forEach(function (image) {
        if (!imageUrl || image.tagName.toLowerCase() !== 'img') return;
        image.src = imageUrl;
        image.removeAttribute('srcset');
      });
      renderDialogGift(product, state.data.giftCards, state.currentPurchase ? null : variant.id);

      var variantInput = product.querySelector('[data-vl-blog-product-variant-input]');
      if (variantInput) {
        variantInput.value = variant ? variant.id : '';
        variantInput.setAttribute('value', variant ? variant.id : '');
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var addButton = product.querySelector('[data-vl-blog-product-add]');
      if (addButton) {
        addButton.disabled = !variant || !variant.available;
        var addLabel = addButton.querySelector('[data-vl-blog-product-add-label]');
        if (addLabel) addLabel.textContent = variant && variant.available ? 'Add to Cart' : 'Sold Out';
      }

      var riderHeight = product.querySelector('[data-vl-blog-product-rider-height]');
      if (riderHeight) {
        // Extra-purchase package variants belong to a separate product and do
        // not carry the target bike's rider-height metafield. Use the matching
        // target-product variant (same selected color) just like the PDP does.
        var riderHeightVariant = state.currentPurchase && targetVariant ? targetVariant : variant;
        var height = riderHeightVariant && state.data.riderHeights
          ? state.data.riderHeights[String(riderHeightVariant.id)]
          : '';
        riderHeight.hidden = !height;
        var heightValue = riderHeight.querySelector('span');
        if (heightValue) heightValue.textContent = height || '';
      }

      this.updateOptions(product, state);
    }

    updateOptions(product, state) {
      var selectedOptions = state.selectedOptions;
      var variantApi = global.VelotricProductCardVariant;
      product.querySelectorAll('[data-vl-blog-product-option]').forEach(function (button) {
        var optionIndex = Number(button.getAttribute('data-option-index'));
        var optionName = button.getAttribute('data-option-name') || state.config.optionNames[optionIndex];
        var optionValue = button.getAttribute('data-option-value');
        var optionState = variantApi.getOptionStateForState(state, optionName, optionValue, selectedOptions);
        var exists = optionState.exists;
        var available = optionState.available;
        var isTargetOption = state.currentPurchase
          && variantApi.normalize(optionName) === state.currentPurchase.record.targetOptionNormalized;
        var selected = !isTargetOption && selectedOptions[optionName] === optionValue;

        button.hidden = !exists;
        button.disabled = !available;
        button.classList.toggle('is-selected', selected);
        button.classList.toggle('selected', selected);
        button.classList.toggle('is-unavailable', !available);
        button.classList.toggle('available', available);
        button.classList.toggle('sold-out', exists && !available);
        button.classList.toggle('disabled', !available);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });

      state.extraPurchaseRecords.forEach(function (record) {
        record.products.forEach(function (purchaseProduct) {
          var button = product.querySelector(
            '[data-vl-blog-extra-purchase-product-id="' + String(purchaseProduct.id) + '"]'
            + '[data-vl-blog-extra-purchase-target-option="' + record.targetOptionNormalized + '"]'
          );
          if (!button) return;
          var matches = variantApi.findPurchaseFunnelVariants(
            purchaseProduct,
            record,
            state.config.optionNames,
            state.selectedOptions,
            state.config,
            false
          );
          var available = matches.some(function (variant) { return variant.available; });
          var selected = Boolean(state.currentPurchase
            && state.currentPurchase.product === purchaseProduct
            && state.currentPurchase.record === record);
          button.hidden = !available;
          button.disabled = !available;
          button.classList.toggle('is-selected', selected);
          button.classList.toggle('is-unavailable', !available);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      });

      product.querySelectorAll('[data-vl-blog-product-option-group]').forEach(function (group) {
        var currentValue = group.querySelector('[data-vl-blog-product-current-option]');
        if (!currentValue) return;
        var optionIndex = Number(group.getAttribute('data-option-index'));
        var optionName = state.config.optionNames[optionIndex];
        var purchase = state.currentPurchase;
        currentValue.textContent = purchase && variantApi.normalize(optionName) === purchase.record.targetOptionNormalized
          ? purchase.product.title
          : (selectedOptions[optionName] || '');
      });
    }

    showProductDialog(trigger) {
      if (trigger.disabled) return;
      var product = trigger.closest('[data-vl-blog-product-response]');
      var dialog = product && product.querySelector('[data-vl-blog-product-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      if (this.openDialog && this.openDialog !== dialog && this.openDialog.open) this.openDialog.close();
      this.activeTrigger = trigger;
      this.openDialog = dialog;
      if (!dialog.open) {
        dialog.showModal();
        setBodyLocked(true, this.ownerDocument);
        this.isBodyLocked = true;
      }
      var scrollArea = dialog.querySelector('[data-vl-blog-product-dialog-scroll]');
      if (scrollArea) scrollArea.scrollTop = 0;
      var focusTarget = dialog.querySelector('[data-vl-blog-product-close], [data-vl-blog-product-option], [data-vl-blog-product-add]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    closeProductDialog(dialog, withTransition) {
      if (!dialog || !dialog.open) return;
      var reduceMotion = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!withTransition || reduceMotion) {
        dialog.classList.remove('is-closing');
        dialog.close();
        return;
      }
      if (dialog.classList.contains('is-closing')) return;

      dialog.classList.add('is-closing');
      this.dialogCloseTimer = global.setTimeout(function () {
        this.dialogCloseTimer = null;
        if (dialog.open) dialog.close();
      }.bind(this), 300);
    }

    handleDialogCancel(event) {
      var dialog = event.target;
      if (!dialog.matches || !dialog.matches('[data-vl-blog-product-dialog]')) return;
      event.preventDefault();
      this.closeProductDialog(dialog, true);
    }

    handleDialogClose(event) {
      var dialog = event.target;
      if (!dialog.matches || !dialog.matches('[data-vl-blog-product-dialog]')) return;
      if (this.dialogCloseTimer) global.clearTimeout(this.dialogCloseTimer);
      this.dialogCloseTimer = null;
      dialog.classList.remove('is-closing');
      var shouldRestoreFocus = !this.suppressFocusRestore;
      this.suppressFocusRestore = false;
      this.unlockDialog();
      this.openDialog = null;
      if (shouldRestoreFocus && this.activeTrigger && this.activeTrigger.isConnected) {
        this.activeTrigger.focus({ preventScroll: true });
      }
      this.activeTrigger = null;
    }

    unlockDialog() {
      if (!this.isBodyLocked) return;
      setBodyLocked(false, this.ownerDocument);
      this.isBodyLocked = false;
    }

    handleScroll() {
      if (this.scrollSettleTimer) global.clearTimeout(this.scrollSettleTimer);
      this.scrollSettleTimer = global.setTimeout(function () {
        this.scrollSettleTimer = null;
        this.syncCarousel();
      }.bind(this), 120);
    }

    handleResize() {
      this.syncCarousel();
      if (global.VLInfoMarquee) global.VLInfoMarquee.schedule(this);
    }

    nearestSlideIndex() {
      var slides = Array.from(this.track.children);
      var currentLeft = this.track.scrollLeft;
      var trackInset = parseFloat(global.getComputedStyle(this.track).paddingLeft) || 0;
      var closestIndex = 0;
      var closestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - trackInset - currentLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      }, this);
      return closestIndex;
    }

    syncCarousel(index) {
      var slideCount = this.track ? this.track.children.length : 0;
      this.activeIndex = Math.max(0, Math.min(typeof index === 'number' ? index : this.nearestSlideIndex(), slideCount - 1));
      Array.from(this.dots.children).forEach(function (dot, dotIndex) {
        var active = dotIndex === this.activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      }, this);
      if (this.previousButton) this.previousButton.disabled = this.activeIndex <= 0;
      if (this.nextButton) this.nextButton.disabled = this.activeIndex >= slideCount - 1;
    }

    scrollToIndex(index) {
      var slides = Array.from(this.track.children);
      var nextIndex = Math.max(0, Math.min(index, slides.length - 1));
      var slide = slides[nextIndex];
      if (!slide) return;
      this.activeIndex = nextIndex;
      var trackInset = parseFloat(global.getComputedStyle(this.track).paddingLeft) || 0;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft - trackInset, behavior: 'smooth' });
      this.syncCarousel(nextIndex);
    }
  }

  if (global.customElements && !global.customElements.get(COMPONENT_NAME)) {
    global.customElements.define(COMPONENT_NAME, VlBlogProductShowcase);
  }

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { initShortcodes(global.document); });
    } else {
      initShortcodes(global.document);
    }
    global.document.addEventListener('shopify:section:load', function (event) { initShortcodes(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
